export default el => {
	const dropdowns = el.querySelectorAll('.js-nav-dropdown');

	dropdowns.forEach(dropdown => {
		const btns = dropdown.querySelectorAll('button');

		btns.forEach(btn => {
			btn.addEventListener('click', () => {
				dropdown.classList.toggle('active');
			})
		})
	})

};
